
function getAccessToken() {
    return localStorage.getItem("APIAccessToken") || ""
}

function setAccessToken(token) {
    return localStorage.setItem("APIAccessToken", token)
}

export { getAccessToken, setAccessToken }